/**
 * otpInputDigits reads what an `input` event left in one OTP box.
 *  - code:  a full code arrived in a single box (one-time-code autofill puts the whole
 *           code into the focused box), to be spread across every box like a paste
 *  - digit: the single digit the box should keep ("" to clear it)
 */
export function otpInputDigits(value, boxCount) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length >= boxCount) {
    return { code: digits.slice(0, boxCount), digit: "" };
  }
  return { code: "", digit: digits.slice(-1) };
}
